const theme = {
    fondo: '#F9F9F9',
    colorPrimario: '#007238',
    colorSecundario: '#fbd000',
    verde: '#43A854',
    rojo: '#E34747',
    grisClaro: '#E8EFF1',
    grisClaro2: '#CBDDE2',
    azulClaro: '#8792F1'
}

export default theme;